// extracted by mini-css-extract-plugin
export default {"cls1":"lbrMpdAQrTArWHvcWcy8","cls2":"k820P4hVRAaVLJkjOJGK lbrMpdAQrTArWHvcWcy8","isPhone":"XP_Oybu64skhzR0anOng"};